import { render, staticRenderFns } from "./ModalSimulador.vue?vue&type=template&id=03ae0ba4&scoped=true"
import script from "./ModalSimulador.vue?vue&type=script&lang=js"
export * from "./ModalSimulador.vue?vue&type=script&lang=js"
import style0 from "./ModalSimulador.vue?vue&type=style&index=0&id=03ae0ba4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ae0ba4",
  null
  
)

export default component.exports